module.exports = __webpack_public_path__ + "static/media/fondo-footer.b1eb80d6.svg";